import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';

import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import rehypeStringify from 'rehype-stringify';

export interface IMarkdownContentProps {
  content: string;
}

export async function markdownToHtml(markdown: string): Promise<string> {
  const file = await unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkRehype)
    .use(rehypeStringify)
    .process(markdown);

  return String(file);
}

export default function MarkdownContent(props: IMarkdownContentProps) {
  return (
    <div className='markdown-content'>
      <ErrorBoundary fallback={<span>{props.content}</span>}>
        <Markdown remarkPlugins={[remarkGfm]}>{props.content}</Markdown>
      </ErrorBoundary>
    </div>
  );
}
